import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../../apiV2Request";
import { ServerStateKeys } from "../../ServerStateKeys";
import { OrderV2Dto } from "@sellar-io/api-v2/types";

export const useOpenDistributionOrderList = <
  TData = OrderV2Dto.OpenDistributionOrderListResponseType,
>(
  params: OrderV2Dto.OpenDistributionOrderListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.OpenDistributionOrders,
      params,
    ],
    queryFn: ({ pageParam }) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `orders/v2/open-distribution-orders`,
        params: {
          ...params,
          offset: pageParam,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: { ...options, limit: params.limit },
    }),
  });
};
